import React, { useCallback, useState, useRef, useEffect } from "react";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import "./PageOne.css";
import { allProduitApp } from "../../../Redux/produitReduce";
import { getLotArticle } from "../../../Redux/reclamationReduce";
import { getActiveType } from "../../../Redux/typeReduce";
import { useTranslation } from 'react-multi-lang';
import { useDispatch } from "react-redux";

const PageOne = ({ setBl, nextPageNumber, motifSelect, onButtonClick, setProduitSelect, setLot, setQte, idClaim, setTypeSelect, getProduitSelect, getLot, getQte, getTypeSelect, client }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  //Produit
  const [qte, setQteLocal] = React.useState(getQte);

  const [typeSelect, setTypeSelectLocal] = React.useState(getTypeSelect);

  const [produitSelect, setProduitSelectLocal] = React.useState(getProduitSelect);

  const [lot, setLotLocal] = React.useState(getLot);

  const [codeArticle, setCodeArticle] = React.useState(null);

  const [optionProduit, setOptionProduit] = React.useState([
    {
      value: "",
      label: "Produit",
      isDisabled: true,
    },
  ]);

  const [optionLot, setOptionLot] = React.useState([
    {
      value: "",
      label: "Lot",
      isDisabled: true,
    },
  ]);

  const [optionType, setOptionType] = React.useState([
    {
      value: "",
      label: "Type",
      isDisabled: true,
    },
  ]);

  const getproduit = useCallback(async (client) => {
    var type = await dispatch(allProduitApp({ client }));
    var entities = type.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({ value: e.id, label: e.Designation_1, code_article: e.Code_article });
    });
    setOptionProduit(arrayOption);
  }, [dispatch]);

  const getType = useCallback(async () => {
    var type = await dispatch(getActiveType());
    var entities = type.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({ value: e.id, label: e.nom });
    });
    setOptionType(arrayOption);
  }, [dispatch]);

  const getLotLivraison = useCallback(async (CodeProduit) => {
    var type = await dispatch(getLotArticle({ CodeProduit }));
    var entities = type.payload;
    var arrayOption = [];

    entities.forEach((e) => {
      let lotNettoye = "";

      if (e.Lot) {
        lotNettoye = e.Lot;
      }

      arrayOption.push({ value: lotNettoye, label: lotNettoye });
    });
    setOptionLot(arrayOption);
  }, [dispatch]);

  useEffect(() => {
    getproduit(client);
    getType();
    if (codeArticle != null) {
      getLotLivraison(codeArticle)
    }
    if (produitSelect) {
      getLotLivraison(produitSelect.code_article)
    }
  }, [codeArticle]);

  return (
    <main
      className="pt5 black-80 center"
      style={{ maxWidth: "50%", maxHeight: "30%", margin: "auto" }}
    >
      <form className="measure">
        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
          <h2 className="text-left font-bold">{t("Reclamation.add")}</h2>
          <Row>
            <Col className="pl-1" md="12">
              <Form.Group id="roleClass">
                <label>{t("article")}* </label>
                <Select
                  placeholder={t("article")}
                  className="react-select primary"
                  classNamePrefix="react-select"
                  value={produitSelect}
                  onChange={(value) => {
                    setProduitSelectLocal(value);
                    setProduitSelect(value);
                    setCodeArticle(value.code_article);
                    setBl([])
                    setLot(null)
                    setLotLocal(null)
                  }}
                  options={optionProduit}
                />
              </Form.Group>
            </Col>
          </Row>


          {console.log(lot)}

          <Row>
            <Col className="pl-1" md="12">
              <Form.Group id="roleClass">
                <label>{t("Reclamation.numero_lot")}* </label>
                <Select
                  placeholder={t("Reclamation.numero_lot")}
                  className="react-select primary"
                  classNamePrefix="react-select"
                  value={{ value: lot, label: lot }}
                  onChange={(value) => {
                    console.log(value.value)
                    setLot(value.value);
                    setLotLocal(value.value);
                  }}
                  options={optionLot}
                />
              </Form.Group>
            </Col>
          </Row>
          {motifSelect.value == 3 ? <Row>
            <Col className="pl-1" md="12">
              <Form.Group id="roleClass">
                <label>{t("Reclamation.type_claim")}* </label>
                <Select
                  placeholder={t("Reclamation.type_claim")}
                  className="react-select primary"
                  classNamePrefix="react-select"
                  value={typeSelect}
                  onChange={(value) => {
                    setTypeSelect(value);
                    setTypeSelectLocal(value);
                  }}
                  options={optionType}
                />
              </Form.Group>
            </Col>
          </Row> : null}


        </fieldset>

        <div>
          <br></br>
          <Button
            className="btn-fill pull-right"
            type="button"
            variant="info" onClick={() => onButtonClick("pageone")}
          >
            {t("suivant")}
          </Button>
          {idClaim ?
            null :
            <Button
              className="btn-fill pull-right  ml-3 mr-3"
              type="button"
              variant="info" onClick={() => nextPageNumber(0)} // Navigate back to page one
            >
              {t("précédent")}
            </Button>}

          <br></br>  <br></br>
        </div>
      </form>
    </main>
  );
};

export default PageOne;
